import "./monthPicker.scss";

import { format } from "date-fns";
import * as React from "react";
import { monthsAndYears } from "../../../constants/generals";

export interface IMonthPickerProps {
  years: number[] | string[];
  onClick: Function;
  defaultValue?: string;
  popover?: boolean;
  min?: string;
}

export interface IMonthPickerState {
  year: number;
  showCalender: boolean;
  hideCalender: boolean;
  value: string;
  month: string;
  minMonth?: number;
  minYear?: number;
  currentYear: number;
  currentMonth: number;
}

export class MonthPicker extends React.Component<
  IMonthPickerProps,
  IMonthPickerState
> {
  constructor(props: IMonthPickerProps) {
    super(props);
    this.setPropsAndState(props.defaultValue);
  }
  componentWillReceiveProps(nextProps) {
    let defaultValue = nextProps.defaultValue;
    this.setPropsAndState(defaultValue);
  }
  setPropsAndState = (defaultValue) => {
    const newValue = format(defaultValue.replace(/\-/g, "/"), "MMM YYYY");
    let minMonth, minYear;
    let dateObj = new Date();
    let year = Number(newValue.split(" ")[1]) || dateObj.getFullYear();
    let value = newValue || format(dateObj, "MMM YYYY");
    let month = newValue.split(" ")[0] || format(dateObj, "MMM");
    if (this.props.min) {
      let minDatas = this.props.min.split("/");
      minMonth = Number(minDatas[0]);
      minYear = Number(minDatas[1]);
    }
    this.state = {
      value: value,
      month: month,
      year: year,
      showCalender: false,
      hideCalender: true,
      minMonth,
      minYear,
      currentYear: dateObj.getFullYear(),
      currentMonth: dateObj.getMonth(),
    };
  };
  handleAMonthChange = (month) => {
    this.setState({
      value: `${month} ${this.state.year}`,
      showCalender: false,
      hideCalender: true,
      month,
    });
    let selectedMonth = "";
    let selectedMonthForAPI = "";
    monthsAndYears.map((data) => {
      if (data.label === month.substring(0, 3)) {
        selectedMonth = `${this.state.year}-${data.value}-02`;
        selectedMonthForAPI = `${data.value}01${this.state.year}`;
      }
    });
    this.props.onClick(
      `01-${month}-${this.state.year}`,
      selectedMonth,
      selectedMonthForAPI
    );
  };

  handleClickMonthBox = (e) => {
    this.setState({
      showCalender: !this.state.showCalender,
    });
  };

  render() {
    const {
      minMonth,
      minYear,
      month,
      year,
      currentYear,
      currentMonth,
    } = this.state;
    let showPreviousYears =
      minYear && minYear === this.state.year ? "hide1" : "";
    let showFutureYears = this.state.year === currentYear ? "hide" : "";
    let browserDetection;
    if (window.navigator.userAgent.toLowerCase().indexOf("chrome") > -1) {
      browserDetection = "chrome";
    } else if (
      window.navigator.userAgent.toLowerCase().indexOf("trident") > -1
    ) {
      browserDetection = "ie";
    }
    let pickerLang = {
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      from: "From",
      to: "To",
    };
    if (year === currentYear) {
      pickerLang.months.length = currentMonth + 1;
    }
    /* if(minMonth && minYear && minYear==year) { 
            pickerLang.months = pickerLang.months.slice( minMonth - 1);  
        } */
    return (
      <div
        id="container"
        className="edit month-picker"
        // onBlur={() => this.setState({ showCalender: false })}
      >
        <div className="rmp-container rmp-table show ">
          <div className="rmp-cell">
            <div
              className={
                this.state.showCalender
                  ? "rmp-popup light show"
                  : "rmp-popup-hide  light "
              }
            >
              {browserDetection === "ie" ? (
                <div className="rmp-pad">
                  <div>
                    <label>{this.state.year}</label>
                    <i
                      onMouseDown={() => {
                        this.setState({
                          year: this.state.year - 1,
                        });
                      }}
                      className={`rmp-tab rmp-btn prev ${showPreviousYears}`}
                      data-id="0"
                    >
                      &lt;
                    </i>
                    <i
                      onMouseDown={() => {
                        this.setState({
                          year: this.state.year + 1,
                          showCalender: true,
                        });
                      }}
                      className={`rmp-tab rmp-btn next ${showFutureYears}`}
                      data-id="0"
                    >
                      &gt;
                    </i>
                  </div>
                  <ul>
                    {pickerLang.months.map((month, index) => (
                      <li
                        onMouseDown={() => this.handleAMonthChange(month)}
                        onClick={() => this.handleAMonthChange(month)}
                        className={
                          this.state.month === month &&
                          this.state.year === currentYear
                            ? "rmp-btn active"
                            : "rmp-btn"
                        }
                        data-id={index}
                      >
                        {month}
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div className="rmp-pad">
                  <div>
                    <label>{this.state.year}</label>
                    <i
                      onClick={() => {
                        this.setState({ year: this.state.year - 1 });
                      }}
                      className={`rmp-tab rmp-btn prev ${showPreviousYears}`}
                      data-id="0"
                    >
                      &lt;
                    </i>
                    <i
                      onClick={() => {
                        this.setState({ year: this.state.year + 1 });
                      }}
                      className={`rmp-tab rmp-btn next disable ${showFutureYears}`}
                      data-id="0"
                    >
                      &gt;
                    </i>
                  </div>
                  <ul>
                    {pickerLang.months.map((month, index) => (
                      <li
                        onClick={() => this.handleAMonthChange(month)}
                        className={
                          this.state.month === month &&
                          this.state.year === currentYear
                            ? "rmp-btn active"
                            : "rmp-btn"
                        }
                        data-id={`0:${index + 1}`}
                      >
                        {month}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
          {browserDetection === "ie" && this.props.popover ? (
            <div className="box" onMouseDown={this.handleClickMonthBox}>
              <label>{this.state.value}</label>
            </div>
          ) : (
            <div className="box" onMouseDown={this.handleClickMonthBox}>
              <label>{this.state.value}</label>
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/MonthPicker/index.tsx